// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"28fb5751","774":"6c6d2b3e"}[chunkId] + ".chunk.js";
};